enum TableFilterType {
  Date = 'date',
  String = 'string',
  Number = 'number',
  Boolean = 'boolean',
  Currency = 'currency',
}

export default TableFilterType;
